module.exports = __webpack_public_path__ + "static/media/Colette Curve Super King Headboard - 200 cm.1db279e2.jpg";